import { GanttRowIntersection } from '../GanttRowIntersection';
import { GanttSingleQueue } from '.';
import { GanttQueue } from '../types';
import { useProductionPlanQueryParams } from '../../hooks';
import { useProductionTaskLocate } from '../hooks';
import { useEffect } from 'react';
import { selectGanttInstanceData, useGanttStore } from '../store';
import { useGanttInstanceId } from '../utils';

export type GanttQueuesRendererProps = {
  ganttQueues: GanttQueue[];
};

export const GanttQueuesRenderer = ({ ganttQueues }: GanttQueuesRendererProps) => {
  useTaskLocateEffect();

  return ganttQueues.map((queue, index) => (
    <GanttRowIntersection ganttQueues={ganttQueues} key={queue.id} queueId={queue.id}>
      <GanttSingleQueue index={index} queueData={queue} />
    </GanttRowIntersection>
  ));
};

export const useTaskLocateEffect = () => {
  const instanceId = useGanttInstanceId();
  const { queryParams } = useProductionPlanQueryParams();
  const isAvailable = useGanttStore((state) => {
    const queue = selectGanttInstanceData(instanceId)(state).queues.find((queue) => queue.id === queryParams.queueId);
    const task = queue?.queueNodes.find((task) => task.id === queryParams.taskId);
    return !!task;
  });
  const locateGanttTask = useProductionTaskLocate();

  useEffect(() => {
    if (queryParams.taskId && queryParams.queueId && isAvailable) {
      locateGanttTask({
        queueId: queryParams.queueId,
        taskId: queryParams.taskId,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAvailable]);
};
